var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"content-left"},[_c('div',{staticClass:"left-container"},[_c('router-view')],1)]),_c('div',{staticClass:"content-right"},[_c('div',{staticClass:"right-container"},[_c('author-contact-us')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }